import styled from 'styled-components';
import { em,rem } from 'polished';
import { Heading } from 'elements';
import { colors } from 'core/theme';
import { media, Flex } from 'core/layout';

export const FlexGroup = Flex.extend`
  ${media.tablet`
    display: block;
  `};
`;

export const StyledTermAnchor = styled.ul`
    list-style: none;
    margin: 1em 0;
    padding:0;
    li {
        margin:${em(8)} 0;
        a {
            padding-left: ${em(18)};
            position:relative;

            &:before {
                content:'';
                position:absolute;
                width: ${em(10)};
                height:1px;
                top:50%;
                left:2px;
                background-color:${colors.subtleText};
            }
        }
    }
`;

export const StyledHeading = styled(Heading)`
    margin-bottom: 1em !important;
    ${media.tabletSmall`
       font-size: ${rem(22)};
    `};
`;

export const StyledList = styled.ul`
    list-style: none;
    margin-bottom: 0;
    padding-left: 0;
`;


export const StyledP = styled.p`
    color: ${colors.lightText};
    ${media.tabletSmall`
       font-size: ${rem(12)};
    `};
`;

export const StyledH218 = styled.h2`
    font-size: ${em(18)};
    font-weight:400 !important;
    padding-left: calc(100% / 7);
    ${media.tabletSmall`
       padding-left: 0;
    `};
`;



export const ListHeading = styled.div`
    font-size: ${em(18)};
    color: ${colors.subtleText};
    padding-bottom: 0.5em;
    border-bottom: 1px solid ${colors.hairline};
    margin-bottom: 1.75em;

    & > span {
        font-size: ${em(34, 18)};
        font-weight: 500;
        color: ${colors.text};
    }
`;

export const StyledFilter = styled.div`
    & + & {
        margin-top: 1em;
    }

    ${media.tabletSmall`
      &:last-child {
        margin-bottom: 4em;
      }
    `};
`;

export const FilterLabel = styled.span`
    font-size: ${em(14)};
    color: ${colors.subtleText};
    display: inline-block;
    margin-bottom: 0.25em;
`;

export const SatursLabel = styled.h4`
    font-size: ${rem(16)};
    font-weight:400 !important;
    margin-bottom: ${rem(16)};
`;

export const HideWhenPrint = styled.div`
      @media print {
        display: none;
      }
`;



// WEBPACK FOOTER //
// ./src/pages/KontaktiRezultati/styled.js